var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-card"},[_c('div',{staticClass:"chart-header"},[_c('h3',{staticClass:"chart-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("header-actions")],2),_c('div',{staticClass:"chart-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }